export enum Cmd {
  BUY = 0,
  SELL = 1,
  BUY_LIMIT = 2,
  SELL_LIMIT = 3,
  BUY_STOP = 4,
  SELL_STOP = 5,
  HEDGED = 6,
}

export enum OrderStatusType {
  OPEN = 1,
  PENDING = 2,
  CLOSED = 3,
}

export enum TradeSide {
  SELL = 'sell',
  BUY = 'buy',
}

export enum OrderType {
  Market = 'market',
  Limit = 'limit',
}

export enum TransactionType {
  LOTS = 'lots',
  PERCENT = 'percent',
}

export enum SLTPUnit {
  PRICE = 'price',
  PIPS = 'pips',
}

export enum TradeExitType {
  TP = 'TP',
  SL = 'SL',
}

export enum SocketCmd {
  OPEN = 1,
  CLOSE = 3,
}
